import { useQuery } from "@tanstack/react-query";
import taskerService from "../../../services/taskerService";
import { resolveMaxLength } from "../utils/textLimits";

export function useRemarksMaxLength(
  formId: string | undefined,
  fieldName: string,
): number {
  const query = useQuery({
    queryKey: ["reviewer-form-schema", formId],
    queryFn: () =>
      taskerService.getFormSchema(formId as string, undefined, "reviewer"),
    enabled: Boolean(formId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
  const field = query.data?.fields.find((f) => f.name === fieldName);
  return resolveMaxLength(field?.maxLength, "REMARKS");
}
